import { render } from "./plusbutton.vue?vue&type=template&id=f5fbe9a2"
import script from "./plusbutton.vue?vue&type=script&lang=js"
export * from "./plusbutton.vue?vue&type=script&lang=js"

import exportComponent from "D:\\startup\\gtdhtml5\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__